/* Summit service form contextual product panel. Safe to load in an unpublished theme. */
(function(){
 function init(section){
  if(!section||section.dataset.stpContextReady==="yes")return;
  section.dataset.stpContextReady="yes";
  var params;try{params=new URLSearchParams(window.location.search)}catch(e){return}
  var part=(params.get("part")||"").trim().slice(0,120);
  var handle=(params.get("product")||"").trim();
  if(!/^[a-zA-Z0-9][a-zA-Z0-9-]{0,200}$/.test(handle))handle="";
  var card=section.querySelector(".stp-request__reference");
  var partElement=section.querySelector(".stp-request__reference-part");
  var partLine=section.querySelector(".stp-request__reference-partline");
  var back=section.querySelector(".stp-request__reference-link");
  var hidden=section.querySelector("[data-stp-product-reference]");
  var name=section.querySelector(".stp-request__reference-name");
  var category=section.querySelector(".stp-request__reference-category");
  var image=section.querySelector(".stp-request__reference-image");
  if(!card||!partElement)return;
  var form=section.querySelector('form');
  if(form){
    [["stp_make","contact[Equipment manufacturer]",90],["stp_model","contact[Equipment model]",100],["stp_serial","contact[Machine serial number]",80]].forEach(function(entry){
      var value=(params.get(entry[0])||"").trim().slice(0,entry[2]);
      var field=Array.prototype.find.call(form.querySelectorAll("input"),function(input){return input.name===entry[1]});
      if(field&&value&&!field.value)field.value=value;
    });
    var selected=(params.get("stp_machine")||"").trim().slice(0,120);
    if(!selected&&params.get("stp_make")&&params.get("stp_model"))selected=(params.get("stp_make").trim()+" "+params.get("stp_model").trim()).slice(0,120);
    if(selected){
      var hiddenMachine=form.querySelector("[data-stp-service-machine]");
      if(!hiddenMachine){
        hiddenMachine=document.createElement("input");
        hiddenMachine.type="hidden";
        hiddenMachine.name="contact[Equipment selected]";
        hiddenMachine.setAttribute("data-stp-service-machine","");
        form.appendChild(hiddenMachine);
      }
      hiddenMachine.value=selected;
      form.addEventListener("submit",function(){
        var makeField=form.querySelector('input[name="contact[Equipment manufacturer]"]');
        var modelField=form.querySelector('input[name="contact[Equipment model]"]');
        var makeValue=makeField?makeField.value.trim():"";
        var modelValue=modelField?modelField.value.trim():"";
        hiddenMachine.value=makeValue&&modelValue?(makeValue+" "+modelValue).slice(0,120):selected;
      },true);
    }
  }
  if(!part&&!handle)return;
  card.hidden=false;
  partElement.textContent=part||"See product below";
  if(!part&&partLine)partLine.hidden=true;
  if(!handle)return;
  var backUrl=new URL("/products/"+encodeURIComponent(handle),window.location.origin);
  ["stp_make","stp_model","stp_machine","stp_serial","preview_theme_id"].forEach(function(key){
    var value=params.get(key);
    if(value&&(key!=="preview_theme_id"||/^[0-9]{6,20}$/.test(value)))backUrl.searchParams.set(key,value);
  });
  if(back){back.href=backUrl.pathname+backUrl.search;back.hidden=false}
  if(hidden)hidden.value=window.location.origin+"/products/"+encodeURIComponent(handle);
  fetch("/products/"+encodeURIComponent(handle)+".js",{credentials:"same-origin"})
   .then(function(response){if(!response.ok)throw new Error("missing product");return response.json()})
   .then(function(product){
    if(!product||!product.title)return;
    if(name){name.textContent=product.title;name.hidden=false}
    if(category&&product.type){category.textContent="Category: "+product.type;category.hidden=false}
    if(!part&&partLine&&Array.isArray(product.variants)&&product.variants[0]&&product.variants[0].sku){partElement.textContent=product.variants[0].sku;partLine.hidden=false}
    if(image&&product.featured_image){
     try{var url=new URL(product.featured_image,window.location.origin);
      if(url.protocol==="https:"&&(url.hostname===window.location.hostname||url.hostname==="cdn.shopify.com"||url.hostname.endsWith(".shopifycdn.net"))){image.src=url.href;image.alt=product.title;image.hidden=false}
     }catch(e){}
    }
   }).catch(function(){if(name)name.hidden=true;if(category)category.hidden=true;if(image)image.hidden=true});
 }
 function start(){document.querySelectorAll("[data-stp-service-form]").forEach(init)}
 if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",start);else start();
 document.addEventListener("shopify:section:load",start);
})();
